import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 5c0-.548.452-1 1-1h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm1-3C3.348 2 2 3.348 2 5v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3H5zm2 12h10a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1zm0-8h3a1 1 0 011 1v4a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1zm7 4h3a1 1 0 110 2h-3a1 1 0 110-2zm0-4h3a1 1 0 110 2h-3a1 1 0 110-2z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
